export const PORTABILITY_INFORMATION_RETURN_TIMEOUT = 10000
export const NUMBER_OCCURRENCES = 10

export const TYPE_ERROR = {
  LOCALITIES: "LOCALITIES",
  SALE_PORTABILITY: "SALE_PORTABILITY",
  INVALID_NUMBER: "INVALID_NUMBER",
  DASHBOARD_STATUS: "DASHBOARD_STATUS"
}

export const ACTION_DASH = {
  DASH_ASSET_PARTNER_COUNT: "DASH_ASSET_PARTNER_COUNT",
  DASH_ASSET_ASSIGNEE_COUNT: "DASH_ASSET_ASSIGNEE_COUNT",
  DASH_ASSET_ASSIGNEE_BY_TN: "DASH_ASSET_ASSIGNEE_BY_TN",
  DASH_ASSET_ASSIGNEE_COUNT_BY_STATUS: "DASH_ASSET_ASSIGNEE_COUNT_BY_STATUS",
  DASH_ORDERS_ASSIGNEE_COUNT_BY_TN: "DASH_ORDERS_ASSIGNEE_COUNT_BY_TN",
  DASH_ORDERS_ASSIGNEE_COUNT_BY_STATUS: "DASH_ORDERS_ASSIGNEE_COUNT_BY_STATUS",
  EXPORT_DASH_ASSET_ASSIGNEE_COUNT: "EXPORT_DASH_ASSET_ASSIGNEE_COUNT",
  EXPORT_DASH_ASSET_ASSIGNEE_BY_TN: "EXPORT_DASH_ASSET_ASSIGNEE_BY_TN",
  EXPORT_DASH_ORDERS_ASSIGNEE_COUNT_BY_TN:
    "EXPORT_DASH_ORDERS_ASSIGNEE_COUNT_BY_TN"
}



// WEBPACK FOOTER //
// ./src/services/state/fixedVoice/constants.js